import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import { newsList } from "@/mocks/news";

export default function NewsPreview() {
  const sorted = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1));
  const featured = sorted[0];
  const list = sorted.slice(1, 6);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
            最新动漫资讯
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            行业动态、新番情报与作品评测
          </p>
        </div>
        <Link
          to="/news"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          全部资讯
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        <NewsCard news={featured} layout="vertical" />
        <div className="flex flex-col gap-3 md:gap-4">
          {list.map((item) => (
            <NewsCard key={item.id} news={item} layout="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}